import { css } from "styled-components";

const mixins = {
  flexCenter: css`
    display: flex;
    justify-content: center;
    align-items: center;
  `,

  flexBetween: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,

  resetList: css`
    list-style: none;
    padding: 0;
    margin: 0;
  `,
  maxWidth: css`
    width: 90%;
    max-width: ${({ theme }) => theme.dimensions.maxWidth};
    margin: 0 auto;
  `,
  hideScrollbar: css`
    &::-webkit-scrollbar {
      display: none;
    }
  `,
  lineClamp: (lineNo) => css`
    display: -webkit-box;
    -webkit-line-clamp: ${lineNo};
    -webkit-box-orient: vertical;
    overflow: hidden;
  `,
  scrollbar: css`
    & {
      overflow-y: overlay;
      scrollbar-width: thin;
      scrollbar-color: transparent;
    }
    &::-webkit-scrollbar {
      width: 8px;
      height: 80%;
      border-radius: 40px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background: #c4c4c4;
      border-radius: 40px;
      background: transparent;
    }
    &:hover {
      &::-webkit-scrollbar-track {
        background: transparent;
      }
      &::-webkit-scrollbar-thumb {
        background: #cce9da;
        border-radius: 40px;
      }
    }
  `,
};

export default mixins;
